export const SITE_NAME = "https://www.truemenu.in/";
export const SITE_CONTACT = "+91-9922330757";
export const WHATSAPP_URL = "//api.whatsapp.com/send";